<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.webhookSubscriptionId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getWebhookSubscriptionList" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="false" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane"
          :dialog-trigger="dialogtrigger" :dialogItem="editItem" :dialog-method-config="dialogMethodConfig" :pk="pk"
          :dialogReadonly="dialogReadonly">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)" @delete="handleDelete"></ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger, readonly }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12" class="mb-3">
                  <QTextField v-model="item.Url" label="Webhook URL" :disabled="readonly" externaledit
                    :rules="[requiredRule, urlRule]">
                  </QTextField>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <QAutoComplete v-model="item.Topic" :list="topicOptions" :disabled="readonly" textkey="label"
                    valuekey="value" label="Topic" externaledit :rules="[requiredRule]">
                  </QAutoComplete>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <QAutoComplete v-model="item.ActionFlags" :list="actionFlagOptions" :disabled="readonly"
                    textkey="label" valuekey="value" label="Action Flags" multiple chips externaledit
                    :rules="[requiredRule]">
                  </QAutoComplete>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <QTextField v-model="item.Secret" label="Secret" :hint="item.Id ? '' : 'Leave empty to auto-generate'"
                    :disabled="readonly" persistent-hint externaledit>
                  </QTextField>
                </v-col>
                <v-col  cols="12" class="mb-3">
                  <v-divider class="my-4"></v-divider>
                  <div class="d-flex justify-space-between align-center mb-2">
                    <h3>Trigger Filters</h3>
                    <v-btn v-if="!readonly" small color="primary" @click="addFilter(item)">
                      <v-icon left small>mdi-plus</v-icon>
                      Add
                    </v-btn>
                  </div>
                  <v-card v-for="(filter, index) in item.TriggerFilters" :key="index" class="mb-2" outlined>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="4">
                          <QAutoComplete v-model="filter.TriggerFilterOption" :list="filterOptions" textkey="label"
                            :disabled="readonly" valuekey="value" label="Filter Type" externaledit
                            :rules="[requiredRule]">
                          </QAutoComplete>
                        </v-col>
                        <v-col cols="12" md="4">
                          <QTextField v-model="filter.Name" label="Name" externaledit :disabled="readonly"
                            :rules="[requiredRule]">
                          </QTextField>
                        </v-col>
                        <v-col cols="12" md="3">
                          <QTextField v-model="filter.Value" label="Value" externaledit :disabled="readonly"
                            :rules="[requiredRule]">
                          </QTextField>
                        </v-col>
                        <v-col v-if="!readonly" cols="12" md="1">
                          <v-btn icon @click="removeFilter(item, index)" color="error">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/views/admin/settings/webhooks/WebhookSubscriptionListItem.vue";
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";
import ClientAPIMixin from "@/api/ClientAPIMixin.js";
import WebhookSubscriptionMixin from "@/views/admin/settings/webhooks/WebhookSubscriptionMixin.js";

export default {
  name: "AdminWebhookSubscriptionList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
  },
  mixins: [clientAPI, FilterQueryMixin, QInputRuleMixin, ClientAPIMixin, WebhookSubscriptionMixin],

  data() {
    return {
      pk: "WSL-",
      editItem: null,
      dialogtrigger: 1,
      dialogReadonly: false,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createWebhookSubscription',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeWebhookSubscription',
        },
      }
    };
  },

  mounted() { },

  methods: {
    handleadded(item) {
      // Generate secret if empty
      if (!item.Secret) {
        item.Secret = this.generateSecret();
      }
      this.$refs.ListPane.handleadded(item);
    },
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    async handleDelete(item) {
      try {
        await this.deleteWebhookSubscription(item.Id);
        await this.$refs.ListPane.fetch();
      } catch (error) {
        console.error('Error deleting webhook subscription:', error);
      }
    },

    setEditItem(item) {
      this.dialogtrigger++;
      if (item) {
        // Create a copy and ensure TriggerFilters array exists
        // Convert ActionFlags from number to array for multi-select
        this.editItem = {
          ...item,
          TriggerFilters: item.TriggerFilters ? [...item.TriggerFilters] : [],
          ActionFlags: this.parseActionFlags(item.ActionFlags)
        };
        // Set readonly based on locked status
        this.dialogReadonly = item.Locked || false;
      } else {
        // New item
        this.editItem = {
          Id: 0,
          Url: '',
          Topic: null,
          ActionFlags: [],
          Secret: '',
          Locked: false,
          TriggerFilters: []
        };
        this.dialogReadonly = false;
      }
    },

    addFilter(item) {
      if (!item.TriggerFilters) {
        this.$set(item, 'TriggerFilters', []);
      }
      item.TriggerFilters.push({
        Id: 0,
        TriggerFilterOption: 1,
        Name: '',
        Value: ''
      });
    },

    removeFilter(item, index) {
      item.TriggerFilters.splice(index, 1);
    },

    generateSecret() {
      // Generate a random 32-character hex string
      const array = new Uint8Array(16);
      crypto.getRandomValues(array);
      return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
    },

    urlRule: value => {
      if (!value) return true;
      try {
        new URL(value);
        return true;
      } catch {
        return 'Must be a valid URL';
      }
    }
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
    newtrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); },
    newtrigger: function () { this.setEditItem(null); }
  },
};
</script>


<style lang='scss' scoped></style>
